export function IsEmptyOrNullString(str: string) {
  return !str || str.trim().length === 0;
}

export function reverseText(str: string) {
  return str.split("").reverse().join("");
}

export function reverseWordsOrder(str: string) {
  return str.split(" ").reverse().join(" ");
}
